import { render, staticRenderFns } from "./TypeOfRequests.vue?vue&type=template&id=0717e914"
import script from "./TypeOfRequests.vue?vue&type=script&lang=ts"
export * from "./TypeOfRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports